angular.module('bmsApp.dashboard')
	.controller('OnlineAvailabilityModalCtrl', OnlineAvailabilityModalCtrl);

OnlineAvailabilityModalCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'$modalInstance',
	'EcomDashboardSvc',
	'LicenseOptionsSvc',
];

function OnlineAvailabilityModalCtrl($scope, $state, $q, $modalInstance, EcomDashboardSvc, LicenseOptionsSvc) {
	let self = this;
	let handlers = {};

	let form = {
		validator: {
			config: {},
			api: {}
		},
		processing: false,
		duration: 60,
	};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
		form: form,
		params: {},
		options: {},
	});

	handlers.init = () => {
		self.loading = true;
		let promises = {
			licenses: LicenseOptionsSvc.license()
				.then((response) => {
					self.options.licenses = response.data.options;
				}),
		};
		$q.all(promises)
			.then((response) => {
				self.loading = false;
			});

		self.selectDefaultMonth();
	};

	self.setSelectedDateRange = () => {
		let dateFrom = self.selectedMonth.clone()
			.startOf('month')
			.startOf('week');
		// Always show 6 week calendar month since it will be a consistent height
		let dateTo = dateFrom.clone()
			.add(5, 'week')
			.endOf('week');
		angular.extend(self.params, {
			date_from: dateFrom,
			date_to: dateTo,
		});
	};

	self.selectDefaultMonth = () => {
		self.selectedTimeSlot = undefined;
		angular.extend(self.form, {
			selected_time_slot: self.selectedTimeSlot,
		});
		self.selectedMonth = moment.utc();
		self.setSelectedDateRange();
	};

	self.changeMonth = (amount) => {
		amount = amount || 1;
		self.selectedMonth.add(amount, 'month');
		self.setSelectedDateRange();
		// TODO: Check step position
		lookupAvailability();
	};

	function lookupAvailability() {
		if (self.form.validator.api.valid()) {
			let deferred = $q.defer();
			let params = {
				from: self.params.date_from,
				to: self.params.date_to,
				postcode: self.form.postcode,
				duration: self.form.duration,
				licenseId: self.form.license.id,
			};

			self.availabilityPromise = EcomDashboardSvc.getAvailability(params);
			self.availabilityPromise.then((response) => {
				self.availabilityWeeks = response.data.available_week_collection;
				delete self.availabilityPromise;
				deferred.resolve();
			});
			return deferred.promise;
		}
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.cancel = () => {
		$modalInstance.dismiss('cancel');
	};

	handlers.viewAvailabilityClick = () => {
		lookupAvailability();
	};

	handlers.availabilityDayClicked = (day) => {
		let selected = !!day.selected;
		angular.forEach(self.availabilityWeeks, (week) => {
			angular.forEach(week.date_collection, (weekDay) => {
				if (weekDay === day) {
					return;
				}
				weekDay.selected = false;
			});
		});
		if (day.available_slot_collection.length) {
			day.selected = !selected;
		}
		else {
			// no selection if there are no slots
			day.selected = false;
		}
	};

	handlers.timeSlotClicked = (timeSlot) => {
		self.selectedTimeSlot = timeSlot;
	};

}